{
  "api_token_create": "Create token",
  "api_token_generate_title": "New API token",
  "api_token_lifetime": "Lifetime",
  "api_token_lifetime_unlimited": "No expiration",
  "api_token_lifetime_custom": "Custom period",
  "api_token_lifetime_days": "Number of days",
  "api_token_created_title": "Save your API token",
  "api_token_created_warning": "The token is visible only now",
  "api_token_created_description": "Copy it and keep it somewhere safe — we won't be able to show it again later.",
  "api_token_value": "Token",
  "api_token_copy": "Copy token",
  "api_token_valid_to": "Valid until {date}",
  "all_docs": "All docs",
  "esign_requests": "E-sign requests",
  "esign_created_by_me": "I've created",
  "esign_envelopes_completed_of": "{completed} of {total} completed",
  "esign_signed_of": "{signed} of {total} signed",
  "esign_acknowledged_of": "{signed} of {total} acknowledged",
  "print_generated_with": "Generated with %APP_NAME%",
  "esign_evidence_auth_email_otp": "Email one-time code",
  "esign_evidence_ip": "IP address",
  "esign_evidence_timeline": "Timeline",
  "esign_evidence_verification": "Verification",
  "esign_status_pending": "Pending",
  "esign_status_signed": "Signed",
  "esign_status_acknowledged": "Acknowledged",
  "esign_status_cancelled": "Cancelled",
  "esign_cancel_request_submit": "Cancel request",
  "esign_cancel_request_confirm_title": "Cancel signature request?",
  "esign_cancel_request_confirm_text": "Employees who haven't signed yet won't be able to sign. Signatures already added will be kept.",
  "esign_signing_status": "Signing status",
  "esign_signing_progress": "Signing progress",
  "esign_status_awaiting_signature": "Awaiting signature",
  "esign_status_awaiting_acknowledgment": "Awaiting acknowledgment",
  "access_data_for_all_employees": "Access data for all employees",
  "access_data_for_all_employees_description": "Members with this role can access data for all employees.",
  "access_disabled": "Access disabled",
  "account_email": "Account email",
  "account_general_security": "General security",
  "account_localisation": "Localisation",
  "account_localisation_caption": "Language, timezone",
  "account_manage_personal_info_description": "Manage personal info in your <profile>profile</profile>",
  "account_notifications_caption": "Manage %APP_NAME% notifications",
  "account_overview": "Account overview",
  "account_recruitment_caption": "Integrations and extension",
  "account_security_caption": "Password & authentication",
  "account_settings": "Account settings",
  "account_theme_caption": "Choose interface color scheme",
  "email_provider": "Email provider",
  "email_provider_caption": "Connect your work email and communicate with candidates in %APP_NAME%",
  "email_servers_provider_caption": "Any other SMTP/IMAP provider",
  "extension_style": "Extension style",
  "add_action": "Add action",
  "add_comment_to_employment": "Add comment for contract change...",
  "add_comment_to_position": "Add comment for position change...",
  "add_link": "Add link",
  "add_members": "Add members",
  "find_out_more": "Find out more",
  "add_new_teammate": "Add a new teammate",
  "add_or_search_field": "Add or search field",
  "additional_compensation": "Additional compensation",
  "additional_compensation_empty_state_description": "Add bonuses, allowances, or other compensation types to track extra payments beyond base salary",
  "additional_compensation_empty_state_title": "No additional compensations yet",
  "address": "Address",
  "address_line_1": "Address line 1",
  "address_line_2": "Address line 2",
  "all_active_employees": "All active employees",
  "all_employees": "All employees",
  "already_have_an_account": "Already have an account?",
  "amount_money": "Amount",
  "amount_money_gross": "Amount gross",
  "amount_money_net": "Amount net",
  "anonymous_bug": "Just some bug",
  "anonymous_cow": "Honest cow",
  "anonymous_dog": "Dog who saw too much",
  "anonymous_dragon": "Swamp whisperer",
  "anonymous_koala": "Koala on mute",
  "anonymous_panda": "Panda in the shadows",
  "anonymous_penguin": "Sleepless penguin",
  "anonymous_shrimp": "Red shrimp",
  "anonymous_squirrel": "Hidden squirrel",
  "app_name": "%APP_NAME%",
  "app_update_available_button": "Refresh",
  "app_update_available_description": "We've released a new version with the latest improvements. Please update to stay current",
  "app_update_available_title": "Update available",
  "apply_settings_to_another_role": "Apply these settings to another role",
  "service_user_create": "Create user",
  "service_user_edit": "Edit user",
  "service_users": "Service users",
  "service_user_delete_confirm": "This user will be deleted and will lose access to the API.",
  "roles_service_users": "Service users roles",
  "roles_service_users_description": "Create roles for service users and apply them based on defined rules",
  "apply_to_description": "Add one or more rules. Only employees who match all conditions will be included.",
  "apply_to_employees": "Whose data can members access?",
  "apply_to_employees_description": "Define which employee records this role can view and modify",
  "assign_department_head_description": "Assigns the department's manager to lead the department where the terminated employee was a manager. If disabled, this department will have no manager",
  "assign_department_head_title": "Assign department manager",
  "assign_employees": "Assign to employees",
  "assign_employees_description": "All rules combine to create a comprehensive selection",
  "assign_employees_to_this_role": "Assign employees to this role",
  "assign_service_user": "Assign to service users",
  "assign_service_user_description": "Select the service users this role applies to.",
  "select_service_users": "Select service users",
  "assign_manager_to_subordinates_description": "Automatically assigns the new manager to the department's subordinates. If disabled, subordinates' manager will remain unchanged",
  "assign_manager_to_subordinates_title": "Assign new manager to subordinates",
  "assign_position": "Assign position",
  "authentication": "Authentication",
  "authentication_methods": "Authentication methods",
  "two_factor_authentication": "Two-factor authentication",
  "base_salary_gross": "Base salary gross",
  "base_salary_net": "Base salary net",
  "birth_date": "Birth date",
  "birth_date_visibility_edit": "Edit and view full birth date",
  "birth_date_visibility_view": "View full birth date",
  "birthday": "Birthday",
  "birthday_display": "Birthday display",
  "birthday_display_caption": "If \"None\" is selected, editing is disabled, and the organization-level setting is applied by default",
  "birthday_display_full": "Full",
  "birthday_display_none": "Hide",
  "birthday_display_settings": "Birthday display settings",
  "birthday_display_settings_permission_edit": "Use and change setting",
  "birthday_display_settings_permission_edit_description": "Same as above, plus the employee can change their setting in profile",
  "birthday_display_settings_permission_none": "Use organization setting",
  "birthday_display_settings_permission_none_description": "Uses the organization setting",
  "birthday_display_settings_permission_view": "Use employee setting",
  "birthday_display_settings_permission_view_description": "Shows the full date, day and month, or hides the birthday based on the employee setting",
  "name_display_level": "Name visibility",
  "name_display_level_full": "Full name",
  "name_display_level_full_description": "Shows the employee's first and last name in full",
  "name_display_level_initial": "First name and last-name initial",
  "name_display_level_initial_description": "Shows the employee's first name and the first letter of their last name",
  "name_display_level_first_only": "First name only",
  "name_display_level_first_only_description": "Shows only the employee's first name",
  "birthday_display_short": "Day and month",
  "calendar_days": "Calendar days",
  "calendar_holiday_copy_from_description": "Are you sure you want to copy all dates from the previous year? This action will duplicate all working holidays, non-working holidays, and compensated days into the current year's calendar",
  "calendar_holiday_date_compensated_description": "When a public holiday falls on a weekend (e.g., Sunday), an alternative day off (e.g., Monday) is provided to ensure employees still benefit from the holiday",
  "calendar_holiday_date_compensated_title": "Rescheduling of a day off",
  "calendar_holiday_date_non_working_description": "These are official public holidays when employees are not expected to work",
  "calendar_holiday_date_non_working_title": "Non-working holiday",
  "calendar_holiday_date_type": "Date type",
  "calendar_holiday_date_working_description": "These days are designated holidays but remain regular workdays unless the employee explicitly takes leave. Employees work as usual unless they request time off",
  "calendar_holiday_date_working_title": "Rescheduling of a workday",
  "calendar_holiday_country_sync_description": "National public holidays for the current and next year are added automatically and refreshed every week. Any changes you make by hand always take priority and are never overwritten or restored by the sync.",
  "calendar_holiday_country_sync_title": "Holidays sync automatically",
  "calendar_holiday_edit_title": "Holiday",
  "calendar_holiday_new": "New holiday",
  "calendar_holiday_policy": "Holiday policy",
  "calendar_holidays_empty_state_description": "Policies are used in Time off accruals",
  "calendar_holidays_empty_state_title": "No holidays policies",
  "calendar_holidays_title": "Holiday policies",
  "calendar_holidays_title_filter_description": "Select the locations, departments, and divisions this policy should apply to. You can combine multiple filters",
  "clear_selection": "Clear selection",
  "calendar_holidays_title_filter_title": "Who does this policy apply to?",
  "calendar_holidays_title_short": "Holiday policies",
  "change_background": "Change background",
  "change_background_caption": "Upload a new background image",
  "change_compensation": "Change compensation",
  "change_compensation_caption": "Update salary and pay details",
  "change_employment": "Change employment",
  "change_employment_caption": "Update employment type and start date",
  "change_position": "Change position",
  "change_position_caption": "Update job title, department, and reporting",
  "change_work_details": "Change work details",
  "change_work_details_caption": "Position, employment, compensation, termination",
  "channels": "Channels",
  "check_employee_roles": "Check employees' roles",
  "choose_hire_date": "Choose start date",
  "choose_when_employee_start": "Choose when the employee officially starts",
  "city": "City",
  "code_for_connection": "Connection code",
  "codes_for_backup": "Backup codes",
  "company_details": "Company details",
  "company_details_description": "In the Organization settings you can fill in the necessary information about your company",
  "compensation": "Compensation",
  "compensation_change_reason": "Compensation change reason",
  "compensation_change_reasons": "Compensation change reasons",
  "compensation_date": "Compensation date",
  "compensation_type": "Compensation type",
  "compensation_types": "Compensation types",
  "compensation_rollup_incomplete_description": "Not included in the total: {lines}",
  "compensation_rollup_unknown_lines": "lines with missing amounts or exchange rates",
  "compensation_rollup_estimated_description": "The value is estimated because periods were converted.",
  "compensation_package_lines": "Compensation components",
  "compensation_line_component": "Component",
  "compensation_line_gross": "Gross",
  "compensation_line_net": "Net",
  "compensation_line_currency_separator": "in",
  "compensation_before_change": "Before",
  "compensation_after_change": "After",
  "compensation_add_line": "Add compensation",
  "compensation_totals": "Total compensation",
  "compensation_gross_rollup": "Gross",
  "compensation_net_official_rollup": "Official net",
  "compensation_net_actual_rollup": "Actual net",
  "compensation_total_cost_rollup": "Total cost of employment",
  "compensation_summary_total_cost": "Total cost of employment",
  "compensation_summary_total_cost_description": "The company's total cost for the employee, including employer contributions and compensation outside payroll.",
  "compensation_summary_gross_description": "Compensation before deductions, excluding compensation outside payroll.",
  "compensation_summary_net": "Net",
  "compensation_summary_net_description": "The amount the employee receives, including compensation outside payroll.",
  "compensation_summary_breakdown": "Breakdown",
  "compensation_line_change_added": "Added",
  "compensation_line_change_removed": "Removed",
  "compensation_line_change_changed": "Changed",
  "compensation_component_kind": "Component kind",
  "compensation_component_kind_earning": "Payment",
  "compensation_component_kind_deduction": "Deduction",
  "compensation_component_kind_employer_contribution": "Employer contribution",
  "compensation_component_calculation_settings": "Calculation settings",
  "compensation_component_is_included_in_gross": "Included in gross",
  "compensation_component_is_included_in_gross_description": "Include this component when calculating the employee's gross compensation.",
  "compensation_component_is_payable_to_employee": "Paid to the employee",
  "compensation_component_is_payable_to_employee_description": "Include this component in the amount paid to the employee.",
  "compensation_component_is_included_in_total_cost": "Included in company cost",
  "compensation_component_is_included_in_total_cost_description": "Include this component in the company's total employee cost.",
  "compensation_component_is_off_payroll": "Outside payroll",
  "compensation_component_is_off_payroll_description": "This component does not pass through payroll.",
  "compensation_component_is_statutory_base": "Statutory calculation base",
  "compensation_component_is_statutory_base_description": "Include this component in the base for statutory calculations.",
  "create_compensation_component": "Create compensation component",
  "edit_compensation_component": "Edit compensation component",
  "archive_compensation_component_confirm": "Archive this compensation component?",
  "confirm_and_copy": "Confirm & copy",
  "confirmation_email_sent": "Email Confirmation Sent! Check your inbox at {email} to confirm",
  "contacts": "Contacts",
  "contract": "Contract",
  "contract_details": "Contract details",
  "copy": "Copy",
  "to_copy": "Copy",
  "copy_invitation_link": "Copy invitation link",
  "copy_invitation_link_caption": "Copy the link and choose where the employee receives the sign-in code",
  "copy_invitation_link_email_description": "Choose the email address that will receive the sign-in code when the employee opens the link. The link itself is only copied.",
  "core_company_calendar": "Company calendar",
  "core_company_calendar_description": "Manage corporate events, holidays and important dates for all employees",
  "core_hr": "Core HR",
  "country": "Country",
  "create_document": "Create document",
  "documents_drop_to_upload": "Drop files to upload",
  "documents_uploading_files": "Uploading files...",
  "documents_upload_done": "Upload complete",
  "create_folder": "Create folder",
  "create_message": "Create message",
  "create_new_rule": "Create new rule",
  "rule_group_mode_all": "All of the rules below",
  "rule_group_mode_any": "Any of the rules below",
  "rule_group_mode_combination": "Combination of rule groups",
  "rule_group_add_group": "Add group",
  "rule_group_title": "Group {number}",
  "rule_group_caption": "All rules summarise here",
  "rule_group_or": "OR",
  "create_role_from_settings_caption": "We'll copy everything — except assignment rules",
  "create_role_from_settings_title": "Create a new role with these settings",
  "create_team": "Create team",
  "create_teammate": "Create teammate",
  "data_access_limitations": "Data access limitations",
  "data_access_limitations_description": "Define which employees this role can access",
  "data_access_rules_applied": "Data access rules applied",
  "data_access_rules_applied_tooltip": "Members with this role will only see data for employees allowed by the data access rules.",
  "default_employee_background": "Default employee background",
  "background_apply_to": "Apply background to",
  "background_apply_to_new_employees": "New employees only",
  "background_apply_to_without_own_background": "Employees who haven't changed it",
  "background_apply_to_all_employees": "All employees, including those who changed it",
  "default_theme": "Default theme",
  "delete_employee": "Delete employee",
  "delete_employee_caption": "Permanently remove from the system",
  "delete_employee_confirm": "Are you sure you want to permanently delete this employee? This action cannot be undone.",
  "delete_employee_handover_description": "Select who will take over this employee’s work. %APP_NAME% will automatically transfer responsibilities and close requests that cannot be reassigned",
  "delete_employee_success": "{name} has been deleted",
  "delete_link_question": "Do you want delete this link?",
  "delete_photo": "Remove photo",
  "delete_photo_caption": "Remove the current profile photo",
  "delete_request_confirm_description": "Are you sure you want to delete the request?",
  "delete_rule_question": "Do you want delete this rule?",
  "delete_team": "Delete team",
  "delete_team_question": "Do you want delete this team?",
  "department": "Department",
  "department_lead": "Department lead",
  "department_lead_prefix": "Leads",
  "department_manager": "Department manager",
  "departments": "Departments",
  "all_subordinates": "All subordinates",
  "direct_reports": "Direct reports",
  "no_direct_reports": "No direct reports",
  "employee_overview_no_direct_reports": "No direct reports yet",
  "employee_overview_no_direct_reports_description": "They will appear here once you set this person as manager in coworkers' profiles",
  "employee_overview_no_direct_reports_button": "Assign subordinates",
  "no_department_assigned": "No department assigned",
  "employee_overview_no_department_assigned": "No department assigned",
  "employee_overview_no_department_assigned_description": "Coworkers will appear here once you set a department",
  "employee_overview_no_department_assigned_button": "Assign department",
  "no_department_employees": "No teammates in this department",
  "employee_overview_no_department_employees": "No coworkers in this department yet",
  "employee_overview_no_department_employees_description": "Coworkers will appear here once employees are added to this department",
  "employee_overview_no_department_employees_button": "Go to employees",
  "disable_2fa": "Disable two-factor authentication",
  "disable_2fa_caption": "Reset employee's two-factor authentication",
  "disable_access": "Disable system access",
  "disable_access_caption": "Employee will not be able to log in",
  "disable_access_confirm": "Are you sure you want to disable system access for this employee? They will no longer be able to log in.",
  "division": "Division",
  "divisions": "Divisions",
  "document": "Document",
  "documents": "Documents",
  "esign": "Electronic signatures",
  "edit_employee": "Edit employee profile",
  "edit_employee_caption": "Personal information, birthday, contacts, etc.",
  "edit_employee_menu_title": "Employee profile",
  "edit_employee_sub_caption": "Photo, background, personal details",
  "edit_link": "Edit link",
  "edit_manage_profile": "Edit account settings",
  "edit_manage_profile_menu_title": "Account settings",
  "edit_request": "Edit request",
  "edit_rule": "Edit rule",
  "edit_signing": "Edit signers and fields",
  "edit_signing_description": "Edit who signs and where",
  "edit_team": "Edit team profile",
  "eligible_for_rehire": "Consider for future rehire",
  "email": "Email",
  "esign_add_signer": "Add signer",
  "esign_change_signer": "Change signer",
  "esign_change_type": "Change type",
  "esign_font_size": "Font size",
  "esign_sample_signature": "John Doe",
  "esign_sample_full_name": "John Doe Junior",
  "esign_sample_initials": "JD",
  "esign_sample_job_title": "Software Engineer",
  "esign_sample_job_role": "Engineering",
  "esign_sample_job_level": "Senior",
  "esign_sample_text": "Sample text",
  "esign_sample_yes_no": "Yes / No",
  "esign_field_text": "Text",
  "esign_field_yes_no": "Yes/No",
  "esign_filled_by": "Filled by",
  "esign_filled_by_auto": "Automatically",
  "esign_filled_by_sender": "Sender",
  "esign_filled_by_signer": "Signer",
  "esign_sender_fills_option": "Sender (when sending)",
  "esign_field_required": "Required",
  "esign_field_multiline": "Multiline",
  "esign_delete_signer": "Delete signer...",
  "esign_edit_signer": "Edit signer",
  "esign_field_current_date": "Signature date",
  "esign_field_full_name": "Full name",
  "esign_field_initials": "Initials",
  "esign_field_job_title": "Job title",
  "esign_field_signature": "Signature",
  "esign_click_to_sign": "Click here to sign",
  "esign_continue_reading": "Continue reading",
  "esign_email_verification": "Verify your email",
  "esign_finish_signing": "Sign",
  "esign_status_declined": "Declined",
  "esign_decline": "Decline to sign",
  "esign_decline_title": "Decline to sign",
  "esign_decline_description": "Signing will be cancelled for all participants, and the sender will be notified.",
  "esign_decline_reason_label": "Reason (optional)",
  "esign_decline_withdraw_consent": "I want to receive documents on paper: withdraw my consent to electronic documents",
  "esign_decline_confirm": "Decline",
  "esign_declined_toast": "You declined to sign the document",
  "esign_consent_agree": "I have read the consent and agree to receive and sign documents electronically",
  "esign_consent_disagree": "I don’t agree: decline to sign",
  "esign_i_have_read_and_acknowledge": "I have read and acknowledge",
  "esign_next_field": "Next",
  "esign_otp_code_label": "Verification code",
  "esign_otp_invalid": "Incorrect code.",
  "esign_otp_resend": "Resend code",
  "esign_otp_resend_in": "Resend code in {seconds}s...",
  "esign_otp_resend_inline": "resend code",
  "esign_otp_sent": "We've sent a verification code to",
  "esign_otp_sent_fallback": "your email address",
  "esign_otp_try_again": "Try again or",
  "esign_otp_verified": "Email verified",
  "esign_signing": "Signing",
  "esign_start_signing": "Start",
  "esign_unsigned_fields_left": "{count, plural, one {# unsigned field left in this document} other {# unsigned fields left in this document}}",
  "esign_your_signature": "Your signature",
  "esign_read_and_agree": "Read and acknowledge",
  "esign_sign": "Sign",
  "esign_read_to_end_hint": "Read the document to the end to enable confirmation",
  "esign_ready_to_sign_description": "Request signatures now or come back anytime.",
  "esign_ready_to_sign_title": "Your document is ready to sign",
  "esign_request_now": "Request now",
  "esign_request_awaiting_signature": "Document is awaiting your signature",
  "esign_request_awaiting_acknowledgment": "Document is awaiting your acknowledgment",
  "esign_request_signatures": "Request signatures",
  "esign_request_signatures_description": "Recipient will sign document",
  "esign_acknowledgment_request_sent": "Acknowledgment request sent",
  "esign_request_acknowledgment": "Request acknowledgment",
  "esign_request_acknowledgment_description": "Recipient will read and confirm",
  "esign_request_sent_notified": "{count, plural, one {# recipient has been notified.} other {# recipients have been notified.}}",
  "esign_signature_request_sent": "Signature request sent",
  "esign_recipient_required": "Select at least one recipient",
  "esign_choose_recipient": "Choose recipient...",
  "esign_send_to": "Send to",
  "esign_multiple_recipients": "multiple recipients",
  "rule_total_employees": "{count, plural, one {Total # employee} other {Total # employees}}",
  "rule_names_and_others": "{names} and {count, plural, one {# other} other {# others}}",
  "esign_return_to": "Return to",
  "esign_single_recipient": "single recipient",
  "esign_recipients_count": "{count, plural, one {# recipient} other {# recipients}}",
  "esign_requests_count": "{count, plural, one {# request} other {# requests}}",
  "esign_personas": "Personas",
  "esign_signature_certificate": "Signature certificate",
  "esign_acknowledgment_certificate": "Acknowledgment certificate",
  "esign_show_signature_certificate": "Show signature certificate",
  "esign_show_acknowledgment_certificate": "Show acknowledgment certificate",
  "esign_request_created_by": "Created by",
  "esign_signed_by": "Signed by",
  "esign_acknowledged_by": "Acknowledged by",
  "esign_signed_on_prefix": "On",
  "esign_download_signed_document": "Download signed document",
  "esign_download_acknowledged_document": "Download document",
  "esign_download_report": "Download report",
  "esign_reminder_custom": "Custom…",
  "esign_reminder_custom_title": "Custom interval",
  "esign_reminder_every_days": "{count, plural, one {Every # day} other {Every # days}}",
  "esign_reminder_every_months": "{count, plural, one {Every # month} other {Every # months}}",
  "esign_reminder_every_weeks": "{count, plural, one {Every # week} other {Every # weeks}}",
  "esign_remind_every": "Remind every",
  "esign_reminder_frequency": "Reminder frequency",
  "esign_reminders": "Reminders",
  "esign_reminders_regular": "Regular reminders",
  "esign_reminders_smart": "Smart reminders",
  "esign_select_due_date": "Select due date",
  "esign_select_recipient_first": "Select a recipient first",
  "esign_replace_existing_document": "Replace existing document",
  "esign_replace_source_hint": "The signed document will replace the original file.",
  "esign_no_store_folders": "There are no folders you can save the document to. Contact your administrator.",
  "esign_store_path_docs": "Docs",
  "esign_store_path_profile": "Employee Profile",
  "esign_store_signed_document": "Store signed document",
  "esign_select_custom_field": "Select field",
  "esign_select_employee": "Select employee",
  "esign_signer_custom_field": "Employee from custom field",
  "esign_signer_direct_manager": "Employee's manager",
  "esign_signer_employee": "Employee",
  "esign_signer_select": "Select",
  "esign_signer_specific_employee": "Specific employee",
  "esign_signer": "Signer",
  "esign_signer_type": "Signer type",
  "esign_signers": "Signers",
  "esign_fields_to_fill": "Fields to fill",
  "esign_sender_fields_shared_hint": "These values will be applied to all envelopes. Per-recipient values are not supported.",
  "email_bcc_email": "BCC Email",
  "email_cc_email": "CC Email",
  "email_enter_body": "Enter email body",
  "email_enter_recipient": "Enter recipient email",
  "email_from": "From",
  "email_income_server": "Incoming mail server",
  "email_not_confirmed": "Email not confirmed",
  "email_noun": "Email",
  "email_outgoing_server": "Outgoing mail server",
  "email_personal": "Personal email",
  "email_personal_copied": "Personal email copied",
  "email_placeholder_candidate_email": "Candidate email",
  "email_placeholder_candidate_first_name": "Candidate first name",
  "email_placeholder_candidate_full_name": "Candidate full name",
  "email_placeholder_candidate_last_name": "Candidate last name",
  "email_placeholder_sender_email": "Sender email",
  "email_placeholder_sender_first_name": "Sender first name",
  "email_placeholder_sender_full_name": "Sender full name",
  "email_placeholder_sender_job_title": "Sender job title",
  "email_placeholder_sender_last_name": "Sender last name",
  "email_placeholder_sender_phone": "Sender phone",
  "email_servers_settings": "Email servers settings",
  "email_short": "Email",
  "email_subject": "Subject",
  "email_template": "Email template",
  "email_template_enter_body": "Compose your email template using the rich text editor",
  "email_template_my": "My templates",
  "email_template_private": "Private (visible only to you)",
  "email_template_public": "Public (visible to everyone)",
  "email_template_shared": "Shared",
  "email_templates": "Email templates",
  "email_to": "To",
  "email_with_password_reset_was_sent": "We've sent a password reset link to the email address you provided. Please check your inbox and follow the instructions to reset your password",
  "employee": "Employee",
  "employee_id": "Employee ID",
  "employee_is_member_of_team_template": "{employee_name} is member of our team for {period}",
  "employee_number": "Employee #",
  "employee_number_enabled_title": "Automatic employee numbering",
  "employee_number_enabled_description": "New employees will automatically get an Employee #",
  "employee_number_next_value_title": "Next number",
  "employee_termination_menu_new_description": "To terminate an employee, open Actions -> Change work details.",
  "employee_termination_menu_new_title": "Termination moved to Actions",
  "employees": "Employees",
  "employment": "Employment",
  "employment_contract": "Employment contract",
  "employment_contracts": "Employment contracts",
  "employment_duration": "Employment duration",
  "employment_end_date": "Employment end date",
  "employment_ended": "Employment ended",
  "employment_start_date": "Employment start date",
  "employment_statuses": "Employment statuses",
  "employment_type": "Employment type",
  "employment_types": "Employment types",
  "empty_mention_text": "Try to find an employee",
  "enable_access": "Enable system access",
  "enable_access_caption": "Employee will be able to log in again",
  "enable_access_confirm": "Are you sure you want to enable system access for this employee? They will be able to log in again.",
  "enable_probation_period": "Enable probation period",
  "ends_on": "Ends on",
  "ends_on_period": "Ends on {period_end} ({days_to_end})",
  "enter_code_from_authenticator": "Enter the code from your authenticator app",
  "enter_invitation_body_text": "Enter invitation body text",
  "expiry_days_value": "Expiration period (days)",
  "extension_display_type_popup": "Popup",
  "extension_display_type_popup_side_panel": "Side panel",
  "extension_display_type_setting_title": "Browser extension display mode",
  "extension_appearance_caption": "Choose how the extension opens",
  "extension_appearance_title": "Chrome extension appearance",
  "features": "Features",
  "first_name": "First name",
  "first_scale_options": "First scale options",
  "folder": "Folder",
  "folder_root": "Root",
  "forgot_password": "Forgot password?",
  "frequency": "Frequency",
  "full_name": "Full name",
  "gender": "Gender",
  "login_method_password": "Password sign-in",
  "login_method_password_description": "Allow employees to sign in with their email and password",
  "login_method_google": "Google sign-in",
  "login_method_google_description": "Allow employees to sign in with their Google account",
  "google_workspace_domains": "Google Workspace domains",
  "google_workspace_domains_hint": "Restrict Google sign-in to these Workspace domains. Separate several with a comma; empty means no restriction.",
  "google_workspace_domains_invalid": "Enter a domain, for example yourcompany.com — not a full email address",
  "login_methods_none_working": "At least one sign-in method must be enabled and configured",
  "password_login_unavailable": "Password sign-in is not available for this account. Choose another sign-in method.",
  "entra_sso": "Microsoft Entra ID sign-in",
  "entra_sso_description": "Allow employees to sign in with their Microsoft work account",
  "entra_sso_tenant_ids": "Tenant ID",
  "entra_sso_tenant_ids_hint": "Directory (tenant) ID from Microsoft Entra ID. Separate several with a comma.",
  "entra_sso_tenant_ids_invalid": "Enter a tenant ID as a GUID, for example 00000000-0000-0000-0000-000000000000",
  "entra_sso_tenant_ids_required": "Add at least one tenant ID to enable the sign-in",
  "oidc_sso": "Single sign-on (OpenID Connect)",
  "oidc_sso_description": "Allow employees to sign in through your identity provider: Keycloak, Okta, Auth0 and others",
  "oidc_sign_in_appearance": "Sign-in page appearance",
  "oidc_provider_connection": "Provider connection",
  "oidc_user_data": "User data",
  "oidc_title": "Button title",
  "oidc_title_hint": "Employees see this button on the sign-in page after entering their email",
  "oidc_issuer": "Issuer URL",
  "oidc_issuer_hint": "For Keycloak: https://<host>/realms/<realm>. The OpenID configuration is loaded from this address when you save",
  "oidc_issuer_invalid": "Enter an issuer URL that starts with https://",
  "oidc_client_id": "Client ID",
  "oidc_client_secret": "Client secret",
  "oidc_client_secret_hint": "The secret is saved. Leave the field empty to keep it",
  "oidc_email_claim": "Email claim",
  "oidc_email_claim_hint": "The field containing the user's work email",
  "oidc_email_claim_tooltip": "The ID token claim containing the work email: email, preferred_username or upn.",
  "oidc_scopes": "Scopes",
  "oidc_scopes_hint": "Required scopes: openid, email, profile",
  "oidc_scopes_required": "Add the required scopes: openid, email, profile",
  "oidc_scopes_tooltip": "Add any scopes your provider requires. Keep the required scopes: openid, email and profile are needed to sign in and retrieve user data.",
  "oidc_redirect_uri": "Redirect URI",
  "oidc_redirect_uri_hint": "Add this address to the allowed redirect URIs of the client in your identity provider",
  "ip_allowlist": "IP access",
  "ip_allowlist_enabled": "Allow access only from listed IP addresses",
  "ip_allowlist_enabled_description": "Sign-in, the app, the API and MCP work only from these addresses. Requests from other addresses are rejected",
  "ip_allowlist_networks": "IP addresses and networks",
  "ip_allowlist_networks_hint": "One per line or separated by commas. IPv4 and IPv6, networks in CIDR notation: 203.0.113.0/24, 2001:db8::/32",
  "ip_allowlist_networks_required": "Add at least one address or network",
  "ip_allowlist_current_ip": "Your current IP address: {ip}. It must be in the list, otherwise you cannot save",
  "allowed_domains": "Allowed email domains",
  "allowed_domains_hint": "Work email of an employee can only be changed to an address in these domains. Separate several with a comma; empty means no restriction.",
  "allowed_domains_invalid": "Enter a domain, for example yourcompany.com — not a full email address",
  "grant_access_to_table": "Grant view and edit access for all existing and future columns",
  "groups": "Groups",
  "heads_of_departments": "Heads of departments",
  "help_how_can_i_help_you": "How can I help you?",
  "hire_date": "Start date",
  "hired_on": "Start date",
  "home": "Home",
  "customize_home_screen": "Customize screen",
  "configure_home_screen": "Configure home screen",
  "home_widget_my_company": "My company",
  "settings_home_layout_title": "Home screen",
  "settings_home_layout_description": "Set the default order and visibility of home screen blocks for employees",
  "home_layout_lock": "Lock visibility",
  "home_layout_locked_hint": "Visibility is locked, employees can't change it",
  "onboarding_home_title": "Welcome aboard",
  "preboarding_start": "Start",
  "preboarding_welcome": "Welcome to {company}",
  "preboarding_journey": "Your journey in {company} starts in {days, plural, one {# day} other {# days}}.",
  "preboarding_journey_hint": "A few steps left before your first working day",
  "preboarding_journey_done": "You have completed every step — see you on your first working day.",
  "preboarding_surveys_title": "Surveys to complete",
  "preboarding_esign_title": "Documents to sign",
  "preboarding_tasks_title": "Tasks to complete",
  "preboarding_task_attachments_title": "Attachments",
  "preboarding_empty_title": "Nothing to do yet",
  "preboarding_empty_description": "There is nothing to fill in — see you on your first working day.",
  "preboarding_error_title": "Couldn't load the page",
  "settings_preboarding_title": "Preboarding",
  "settings_preboarding_description": "Set up what a new hire sees before their first day",
  "preboarding_settings_always_shown_title": "Always shown",
  "preboarding_settings_always_shown_description": "Surveys and documents to sign always appear on the preboarding home screen.",
  "preboarding_settings_show_manager": "Show manager",
  "preboarding_settings_show_manager_description": "Display the manager's name, photo and job title on the preboarding home screen",
  "portal_access": "Portal access",
  "portal_access_menu_caption": "See why the employee's portal is limited",
  "portal_access_mode_preboarding": "Limited until start date",
  "portal_access_mode_onboarding": "Limited while flows are running",
  "portal_access_mode_full": "Full access",
  "portal_access_mode_hint": "The employee only sees the surveys and documents assigned to them",
  "portal_access_blocking_now": "Restricts access",
  "portal_access_not_blocking": "No longer restricts",
  "portal_access_blocking_processes": "Flows restricting access",
  "portal_access_no_blockers": "No restrictions",
  "portal_access_no_blockers_preboarding": "The employee gets full access on their first working day.",
  "portal_access_released_hint": "The restriction was lifted manually and can't be brought back.",
  "portal_access_released": "Restriction lifted manually",
  "portal_access_add_workflows": "Add flow...",
  "portal_access_replace_workflows": "Replace flows...",
  "portal_access_add_workflows_hint": "The employee stays on limited access until the selected flows are completed.",
  "portal_access_replace_workflows_hint": "The current restrictions are lifted once the first new flow is launched. The portal opens once all the selected ones are completed.",
  "portal_access_release": "Lift the restriction manually...",
  "portal_access_release_submit": "Lift restriction",
  "portal_access_release_hint": "The employee gets full access right away. Flows that already started keep running.",
  "portal_access_release_hint_preboarding": "The flows stop limiting the portal, but full access opens only on the first working day. Flows that already started keep running.",
  "portal_access_release_success": "Restriction lifted",
  "portal_access_run_success": "Flows launched",
  "portal_access_partial_error": "Some flows were not launched. Retry launches only the failed ones.",
  "portal_access_permission_view_description": "See why an employee's portal is limited",
  "portal_access_permission_edit_description": "See why the portal is limited, launch blocking flows and lift the restriction manually",
  "impersonate_employee": "Log in as",
  "impersonate_employee_caption": "Open the portal in a new tab and work as this employee",
  "impersonation_banner": "You are viewing the portal as {name}. Session ends at {time}",
  "impersonation_ended_close": "Close tab",
  "impersonation_ended_description": "The login session has expired or been ended. Close this tab and start a new one if needed",
  "impersonation_ended_title": "Employee login session ended",
  "impersonation_exit": "Exit",
  "import_data_continue_to_matching": "Continue to data matching",
  "import_data_exit_confirm": "Are you sure you want to exit? All progress will be lost",
  "import_data_file_name": "File name",
  "import_data_history": "Import history",
  "import_data_review_import": "Review import",
  "import_data_start_import": "Start import",
  "import_data_start_new": "Start new import",
  "import_data_step_confirmation": "Confirmation",
  "import_data_step_preset": "Import type",
  "import_data_step_preview": "Preview data",
  "import_data_step_common_settings": "Import settings",
  "import_data_step_match": "Match columns",
  "in_app": "In app",
  "messenger": "Messenger",
  "invitation_link_copied_to_clipboard": "Invitation link copied to clipboard",
  "invite_code_description": "We sent a 6-digit sign-in code to the email address used for the invitation.",
  "invite_code_resend": "Request a new code",
  "invite_invalid_description": "Log in or restore your password",
  "invite_invalid_title": "This invitation has already been used or is not valid.",
  "invite_to_skailer": "Invite employee to %APP_NAME%",
  "invited": "Invited",
  "join_workspace_of_your_team": "Join your team's workspace on %APP_NAME%",
  "last_action": "Last action",
  "last_activity_date": "Last activity",
  "last_name": "Last name",
  "last_working_day": "Last working day",
  "leave_type": "Leave type",
  "legal_entities": "Legal entities",
  "legal_entity": "Legal entity",
  "level": "Level",
  "levels": "Levels",
  "lifecycle_status": "Lifecycle status",
  "lifecycle_active": "Active",
  "lifecycle_inactive": "Inactive",
  "lifecycle_status_employed": "Employed",
  "lifecycle_status_hired": "Hired",
  "lifecycle_status_on_leave": "On leave",
  "lifecycle_status_on_parental_leave": "On parental leave",
  "lifecycle_status_set_date": "Set date",
  "lifecycle_status_terminated": "Terminated",
  "lifecycle_status_terminated_on": "{date} · {ago}",
  "links": "Links",
  "login_organization_placeholder": "Organization",
  "login_organization_session_expired": "Your sign-in has expired. Please log in again.",
  "login_select_organization": "Choose an organization",
  "login_select_organization_subtitle": "Your email works in several organizations. Pick where to sign in.",
  "login_to_platform": "Log in to %APP_NAME%",
  "login_to_platform_subtitle": "Have a great day",
  "make_changes": "Make changes",
  "manage_access": "Manage access",
  "manage_access_caption": "Invitations, 2FA, login access",
  "manual_setup": "Manual setup",
  "manage_compensation": "Manage compensation",
  "manage_compensation_description": "Full access to all compensation fields and history",
  "permission_employee_compensation_lines_title": "Compensation lines",
  "permission_employee_compensation_lines_description": "View or manage the lines that make up an employee's compensation package",
  "permission_employee_compensation_total_cost_title": "Total cost of employment",
  "permission_employee_compensation_total_cost_description": "View the employee's total cost, including employer contributions",
  "permission_reporting_employee_total_cost_title": "Total cost of employment report",
  "permission_reporting_employee_total_cost_description": "View employee total cost reporting. Requires access to the salary report",
  "manage_employment": "Manage employment",
  "manage_employment_description": "Full access to all employment fields and history",
  "manage_position": "Manage position",
  "manage_position_description": "Full access to all position fields and history",
  "manage_profile_caption": "Password, integrations, notifications, etc.",
  "manage_teams": "Manage teams",
  "manage_teams_settings_permission_edit_description": "Full permission to create, modify and remove team assignments",
  "manage_teams_settings_permission_none_description": "Team information hidden from employee profiles",
  "manage_teams_settings_permission_view_description": "Users can see team assignments but not modify them",
  "manage_views": "Manage views",
  "changed_by": "Changed by",
  "manager": "Manager",
  "managers": "Managers",
  "is_manager": "Is a manager",
  "member": "Member",
  "members": "Members",
  "mention": "Mention",
  "mentions": "Mentions",
  "message_from_app": "Message from %APP_NAME%",
  "message_template": "Message template",
  "middle_name": "Middle name",
  "min_length_value": "Minimum length (characters)",
  "my_company_template": "My {company}",
  "my_details": "My details",
  "my_manager": "My manager",
  "my_profile": "My profile",
  "my_subordinates": "My subordinates",
  "name": "Name",
  "name_display_format": "Name display",
  "search_personal_data_placeholder": "Name, surname, other personal data…",
  "set_all_permissions": "You can select an access level for all entries in this section",
  "set_all_permissions_edit": "Maximum access",
  "set_all_permissions_none": "No access",
  "set_all_permissions_select": "Select",
  "set_all_permissions_view": "View access",
  "new_employee": "New employee",
  "new_employee_invitation_sent": "Invitation Sent! An email has been successfully sent to {email}",
  "new_employee_manual_invitation_description": "Email with login instructions will not be automatically sent to the employee. You can send it manually from the employee's profile page",
  "new_mentions": "New @mentions",
  "new_request": "New request",
  "new_team": "Create new team",
  "new_teammate_added": "New teammate added!",
  "news": "News",
  "news_feature_description": "Share company announcements, events, and important updates with your team",
  "no_compensation_assigned": "No compensation assigned",
  "no_documents_created": "No documents added",
  "no_documents_created_description": "Store signed contract, agreements, vacation requests etc.",
  "no_employment_assigned": "No employment assigned",
  "no_position_assigned": "No position assigned",
  "no_team_created": "No team added",
  "employee_overview_no_team_membership": "This employee is not in any teams",
  "employee_overview_no_team_membership_description": "Teams will appear here once you add this employee to at least one team",
  "employee_overview_no_team_membership_button": "Add to team",
  "no_teams_created_description": "Create teams, manage members and roles",
  "no_reminders_sent": "No reminders sent yet",
  "notes": "Notes",
  "notification_settings": "Notification settings",
  "notification_settings_no_available": "No notification settings available",
  "notification_settings_no_available_description": "You currently have no available notification settings.",
  "employee_not_started_yet": "Employee starts on {date}",
  "on_probation_till": "On probation till",
  "onboarding_setup": "Onboarding setup",
  "org_chart_departments": "Departments",
  "org_chart_employees": "Org chart",
  "organization": "Organization",
  "organization_link": "Useful link",
  "organization_links": "Useful links",
  "organization_settings": "Organization settings",
  "organization_view_filter_description": "Control which employees appear when team members first open this section",
  "organization_view_filter_title": "Default employee view",
  "parent_department": "Parent department",
  "password_expired_description": "For security reasons, you need to change your password",
  "password_expired_title": "Your password has expired",
  "password_expiry_days": "Password expiration",
  "password_expiry_days_description": "Require users to change passwords after a certain number of days",
  "password_min_length": "Minimum password length",
  "password_min_length_description": "Set a minimum number of characters for passwords",
  "password_policy": "Password policy",
  "password_updated": "Your password has been successfully updated",
  "people": "People",
  "people_with_activity": "People with activity",
  "peoples_data": "People's data",
  "permission_reporting_export_title": "Export reports",
  "permissions_access_to_leave_timeline": "Access to leave calendar",
  "permissions_access_to_leave_timeline_description": "Access to a calendar of approved leave and other types of absence for employees whose profiles this role can access",
  "permissions_add_new_employees": "Add new employees",
  "permissions_add_new_employees_description": "Allow users to add new employees to the system",
  "permissions_approve_and_reject_leaves": "Approve and decline leaves",
  "permissions_approve_and_reject_leaves_description": "Create, approve, and decline other employees' leave requests, bypassing all restrictions",
  "permissions_ban_employees": "Manage system access",
  "permissions_ban_employees_description": "Allow users to enable or disable employee access to the system",
  "permissions_custom_fields_description": "Configure and sort fields that will be shown in employee profile",
  "permissions_delete_employees": "Delete employees",
  "permissions_delete_employees_description": "Allow users to permanently delete employee profiles from the system",
  "permissions_impersonate_employees": "Log in as employee",
  "permissions_impersonate_employees_description": "Allow users to open the portal on behalf of an employee to see it through their eyes",
  "permissions_employees_search": "Search employees",
  "permissions_employees_search_description": "Search for employees by department, position, or other criteria",
  "permissions_esign_manage_templates_title": "Manage signature markup",
  "permissions_esign_manage_templates_description": "View and manage signature markup on documents",
  "permissions_esign_request_title": "Request signatures",
  "permissions_esign_request_description": "Create signing requests for documents",
  "permissions_esign_download_report_title": "View signing report",
  "permissions_esign_download_report_description": "View the signing report for documents",
  "permissions_manage_approval_policy": "Manage approval policy",
  "permissions_manage_approval_policy_description": "Configure approval flows and rules",
  "permissions_manage_calendar_description": "Time and schedule management",
  "permissions_manage_compensation_change_reasons_description": "Manage reasons for salary adjustments",
  "permissions_manage_compensation_types_description": "Manage types of bonuses and other additional payments",
  "permissions_manage_custom_fields_description": "Configure fields for employee profiles, candidates, jobs, and offers",
  "permissions_manage_data_protection_description": "Manage privacy settings and data protection policies",
  "permissions_audit_log_read": "Audit log",
  "permissions_audit_log_read_description": "Search and view the system audit log with all user actions and systems changes",
  "permissions_manage_departments_description": "Create and manage departments, department heads and organizational structure",
  "permissions_manage_divisions_description": "View, create, or modify divisions within the organization",
  "permissions_manage_email_templates_description": "Create and manage email templates for various purposes",
  "permissions_manage_hiring_flows": "Manage hiring templates",
  "permissions_manage_hiring_flows_description": "Create and configure hiring templates for new employees",
  "permissions_manage_holidays": "Manage holidays",
  "permissions_manage_holidays_description": "Create and manage holiday policies",
  "permissions_manage_import_data_description": "Upload data using files",
  "permissions_manage_integrations_description": "Connect and manage Slack, Google Calendar, Google Workspace and Zoom",
  "permissions_manage_leave_policies": "Manage leave policies",
  "permissions_manage_leave_policies_description": "Set and modify time off rules",
  "permissions_manage_legal_entities": "Manage legal entities",
  "permissions_manage_locations_description": "Manage the locations associated with the organization",
  "permissions_manage_organization_description": "Manage organization settings — name, logo, language etc.",
  "permissions_manage_organization_links_description": "Manage links for employees",
  "permissions_manage_positions_description": "Create and manage positions within the organization",
  "permissions_manage_probation_policies_description": "Configure employee probation policies",
  "permissions_manage_recognitions_description": "Create and manage recognition categories, recognitions and badges",
  "permissions_manage_roles_and_permissions_description": "Create and manage roles and permissions for users",
  "permissions_manage_work_patterns_description": "Manage standard work schedules",
  "permissions_recognitions_mass_gift_description": "Gift recognitions to a group of employees by rules",
  "permissions_reporting_export_description": "Allows to export reports in different formats",
  "permissions_see_employee_directory": "View employee directory",
  "permissions_see_employee_directory_description": "Access and search company employee list",
  "permissions_terminate_employees_description": "Allow users to end an employee's profile in the system",
  "permissions_view_departments_chart": "View departments chart",
  "permissions_view_departments_chart_description": "Provide a visual overview of the departments and their hierarchy",
  "permissions_view_org_chart": "View organization chart",
  "permissions_view_org_chart_description": "Enable access to the company's organizational structure",
  "personal": "Personal",
  "personal_details": "Personal details",
  "personal_information": "Personal information",
  "phone": "Phone",
  "phone_personal": "Personal phone",
  "port": "Port",
  "position": "Position",
  "position_details": "Position details",
  "position_effective_date": "Position date",
  "positions": "Positions",
  "positions_and_levels": "Positions & Levels",
  "prepare_for_signing": "Set up signers and fields",
  "prepare_for_signing_description": "Define who signs and where",
  "preview": "Preview",
  "preview_changes": "Preview changes",
  "probation": "Probation",
  "probation_policies": "Probation policies",
  "probation_policy": "Probation policy",
  "probation_till": "Probation till",
  "profile": "Profile",
  "question_delete_integration": "Do you want delete this integration?",
  "reason": "Reason",
  "ready_for_signing": "Ready for signing",
  "recognitions": "Recognitions",
  "recognitions_mass_gift": "Mass recognition gifting",
  "recipient": "Recipient",
  "reassign_subordinates_to_manager_description": "Automatically reassigns the terminated employee's subordinates to their manager. If disabled, subordinates will have no assigned manager",
  "reassign_subordinates_to_manager_title": "Reassign subordinates to manager",
  "remind": "Remind",
  "remind_everyone": "Remind everyone",
  "reminder": "Reminder",
  "reminder_history": "Reminder history",
  "reminder_message": "Reminder message",
  "customize_reminder_message": "Customize reminder message",
  "enter_custom_subject": "Enter custom subject",
  "enter_custom_body": "Enter custom message body",
  "entity": "Entity",
  "last_reminded": "Last reminded {time}",
  "recovery_codes": "Recovery codes",
  "remove_background": "Remove background",
  "remove_background_caption": "Remove the current background image",
  "rename_view": "Rename view",
  "termination_handover_to": "Handover to",
  "termination_handover_to_description": "Select who will take over this employee’s work when they leave. %APP_NAME% will automatically transfer responsibilities and close requests that cannot be reassigned",
  "require_strong_password": "Require strong passwords",
  "require_strong_password_description": "Passwords must contain uppercase, lowercase, numbers, and special characters",
  "require_tfa": "Require for everyone",
  "send_reminders": "Send reminders",
  "resend_invitation": "Resend invitation",
  "resend_invitation_caption": "Send the invitation email to the employee again",
  "resend_verification_email": "Resend verification email",
  "reset_password": "Reset password",
  "restore_password": "Restore password",
  "role": "Role",
  "role_enter_description": "Describe role",
  "role_type_admin": "Admins have access to everything and can manage all data",
  "role_type_all_employees": "All employees — general access",
  "role_type_all_employees_description": "Assigned to everyone by default. Configure access to colleague data and turn system features on/off for all employees",
  "role_type_manager": "Define what managers can see and edit across their subordinates",
  "role_type_myself": "All people — own data",
  "role_type_myself_description": "Define what employees can see about themselves",
  "role_type_team_leads": "Define what team leads can see and edit across their teams",
  "role_updated": "Role \"{role_name}\" updated",
  "roles": "Roles",
  "roles_and_permissions": "Roles & Permissions",
  "roles_basic": "Basic roles",
  "roles_basic_description": "Roles applied to all members of your team by default, define how they see each others profiles and can edit their own profiles",
  "roles_custom": "Custom roles",
  "roles_custom_description": "Create custom roles and apply them based on defined rules",
  "roles_system": "System roles",
  "roles_system_description": "Roles, automatically assigned by system, based on position of employee",
  "rule_admins": "Admins",
  "rule_affected_employee": "Affected employee",
  "rule_affected_employee_caption": "The employee to whom the flow is applied",
  "rule_affected_employee_custom_field_employee_reference": "Employee from custom field of affected employee",
  "rule_affected_employee_custom_field_employee_reference_caption": "Employee referenced in a custom field of the affected employee",
  "rule_affected_employee_custom_field_employee_reference_subordinates": "Subordinates of employee from custom field",
  "rule_affected_employee_custom_field_employee_reference_subordinates_caption": "Subordinates of the employee referenced in a custom field of the affected employee",
  "rule_affected_employee_direct_manager": "Direct manager of affected employee",
  "rule_affected_employee_direct_manager_caption": "The direct manager of the employee to whom the flow is applied",
  "rule_affected_employee_direct_manager_subordinates": "Subordinates of affected employee's direct manager",
  "rule_affected_employee_direct_manager_subordinates_caption": "Subordinates of the direct manager of the employee to whom the flow is applied",
  "rule_affected_employee_subordinates": "Subordinates of affected employee",
  "rule_affected_employee_subordinates_caption": "Subordinates of the employee to whom the flow is applied",
  "rule_all_active_employees_caption": "All employees except those with Terminated status",
  "rule_custom_field_employee_reference_approval_caption": "Employee referenced in a custom field of the employee",
  "rule_custom_field_employee_reference": "Employee field",
  "rule_custom_field_select": "Select from custom field",
  "rule_custom_field_select_caption": "Filter by a custom field value from a select field",
  "rule_custom_field_select_field_label": "Field on employee profiles",
  "rule_custom_field_select_preview": "Field {field} has {options} selected",
  "rule_department_caption": "Employees in the selected department",
  "rule_department_manager_approval_caption": "The manager of the employee's department",
  "rule_department_manager_title": "Department manager",
  "rule_direct_manager_approval_caption": "The direct manager of the employee",
  "rule_direct_manager_title": "Line manager",
  "rule_division_caption": "Employees in the selected division",
  "rule_employee_caption": "Only the selected employees",
  "rule_employee_approval_caption": "The employee to whom the approval policy is applied",
  "rule_employees_in_custom_field": "Employees referenced in selected fields",
  "rule_employees_in_custom_field_caption": "Everyone referenced in at least one of the selected fields. For example, all HR admins in the company",
  "rule_employees_with_employee_in_custom_field": "Employees referencing selected people",
  "rule_employees_with_employee_in_custom_field_caption": "Employees whose selected fields reference at least one of the people you choose. For example, everyone whose HR Admin is Marina",
  "rule_employees_with_me_in_custom_field": "Employees referencing someone with this role",
  "rule_employees_with_me_in_custom_field_caption": "For each employee with this role, matches employees whose selected fields reference them. For example, each HR admin's employees",
  "rule_cf_reference_fields_label": "Fields on employee profiles",
  "rule_cf_reference_fields_placeholder": "For example, HR Admin",
  "rule_cf_reference_employees_label": "Who must be referenced in these fields",
  "rule_cf_reference_role_employee_hint": "The fields are matched against the employee with this role",
  "rule_cf_reference_preview": "Employees whose fields {fields} reference {employees}",
  "rule_employment_contract_caption": "Filter by the employee's employment contract type",
  "rule_employment_duration_after_date_inclusive": "After date (inclusive)",
  "rule_employment_duration_before_date_inclusive": "Before date (inclusive)",
  "rule_employment_duration_by_period": "By period",
  "rule_employment_duration_calc_mode": "Count by",
  "rule_employment_duration_caption": "How long the employee has been working in the company",
  "rule_employment_duration_condition": "Employment duration condition",
  "rule_employment_duration_custom_date": "Custom date",
  "rule_employment_duration_date_condition": "Date condition",
  "rule_employment_duration_exclude_greater_or_equal": "Exclude: greater than or equal to",
  "rule_employment_duration_exclude_less_or_equal": "Exclude: less than or equal to",
  "rule_employment_duration_greater_or_equal": "Greater than or equal to",
  "rule_employment_duration_include_greater_or_equal": "Include: greater than or equal to",
  "rule_employment_duration_include_less_or_equal": "Include: less than or equal to",
  "rule_employment_duration_less_or_equal": "Less than or equal to",
  "rule_employment_duration_one_month": "1 month",
  "rule_employment_duration_one_year": "1 year",
  "rule_employment_duration_period": "Employment duration period",
  "rule_employment_duration_period_condition": "Period condition",
  "rule_employment_duration_six_months": "6 months",
  "rule_employment_duration_specific_date": "Specific date",
  "rule_employment_duration_three_months": "3 months",
  "rule_employment_type_caption": "Filter by the employee's employment type",
  "rule_group_by_affected_employee": "By affected employee",
  "rule_group_by_attribute": "By employee data",
  "rule_group_by_role": "Managers and team leads",
  "rule_group_relative": "Relative to employee with role",
  "rule_group_scope": "Whole company",
  "rule_heads_of_departments_caption": "Employees appointed as department heads",
  "rule_heads_of_teams_caption": "Employees appointed as team leads",
  "rule_legal_entity_caption": "Employees in the selected legal entity",
  "rule_lifecycle_status_caption": "For example: active, on leave, or terminated",
  "rule_gender_caption": "For example: only female employees",
  "rule_location_caption": "Employees in the selected location",
  "rule_manager_of_direct_manager_approval_caption": "The manager of the employee's direct manager",
  "rule_manager_of_direct_manager_title": "Manager's manager",
  "rule_managers_caption": "Employees who are assigned as managers for other employees",
  "rule_my_department_employees": "Departments I belong to",
  "rule_my_department_employees_caption": "Employees in departments where the employee with this role is a member",
  "rule_my_departments": "Departments I manage",
  "rule_my_departments_caption": "Employees in departments where the employee with this role is assigned as manager",
  "rule_my_subordinates": "My subordinates",
  "rule_my_subordinates_caption": "All subordinates of the employee with this role across all reporting levels",
  "rule_my_team": "Teams I lead",
  "rule_my_team_caption": "Employees in teams where the employee with this role is assigned as team lead",
  "rule_myself": "The employee themself",
  "rule_myself_caption": "Only the employee who was assigned this role",
  "rule_organization": "All employees",
  "rule_organization_caption": "All employees, including employees with Terminated status",
  "rule_job_profile_caption": "Employees with the selected job profile",
  "rule_team_caption": "Employees in the selected team",
  "rule_work_pattern_caption": "Filter by the employee's work pattern",
  "salary": "Salary",
  "job_salary_range": "Gross salary range",
  "job_track": "Job track",
  "job_grade": "Job grade",
  "save_as_new_view": "Save as new view",
  "save_changes_to_view": "Save changes to this view",
  "save_columns_only": "Save sorting and columns only",
  "save_current_filters_and_columns": "Save current filters, sorting and columns",
  "save_new_view": "Save new view",
  "save_view": "Save view",
  "saved_views_feature_description": "Save filters, sorting, and columns to quickly return to them.",
  "saved_views_feature_title": "Save views",
  "saved_views_label": "Saved views",
  "score_mark_average": "Average",
  "score_mark_excellent": "Excellent",
  "score_mark_good": "Good",
  "score_mark_poor": "Below average",
  "second_scale_options": "Second scale options",
  "select_probation_policy": "Select probation policy",
  "select_probation_policy_and_confirm": "Select a policy and confirm end date",
  "send": "Send",
  "send_email": "Send email",
  "send_invitation": "Send invitation",
  "send_invitation_caption": "Send the invitation email to the employee",
  "send_multiple_emails_text": "Confirm multiple email sending",
  "sender": "Sender",
  "server": "Server",
  "set_permissions": "Set permissions",
  "settings_calendar_holidays_description": "Set up holiday schedules for each location",
  "settings_compensation_change_reasons_description": "Configure reasons for salary adjustments",
  "settings_compensation_types_description": "Configure various types of bonuses and other additional payments",
  "settings_departments_description": "Create teams and groups to organize your company",
  "settings_disqualification_reasons_description": "Set standard reasons for candidate rejection",
  "settings_division_description": "Group your teams by function for better organization",
  "settings_employment_contracts_description": "Manage different types of work agreements",
  "settings_employment_types_description": "Set up different ways people can work at your company",
  "settings_features": "Features settings",
  "settings_features_description": "Control which functions are available in your system",
  "webhooks": "Webhooks",
  "webhooks_description": "Manage webhooks for external integrations",
  "webhook_active": "Active endpoint",
  "webhook_active_description": "Events are delivered only while this endpoint is active",
  "webhook_create": "Create webhook",
  "webhook_custom_headers": "Custom headers",
  "webhook_delete_description": "This endpoint will stop receiving events. This action cannot be undone.",
  "webhook_delete_title": "Delete webhook?",
  "webhook_edit": "Edit webhook",
  "webhook_attempt": "Attempt",
  "webhook_delivery_details": "Delivery details",
  "webhook_delivery_empty_description": "Deliveries will appear here after this webhook receives an event or a test delivery is sent",
  "webhook_delivery_history": "Delivery history",
  "webhook_delivery_load_error": "Delivery history could not be loaded",
  "webhook_delivery_status_delivered": "Delivered",
  "webhook_delivery_status_failed": "Failed",
  "webhook_delivery_status_pending": "Pending",
  "webhook_event": "Event",
  "webhook_event_approval_request_approved": "Approval request approved",
  "webhook_event_approval_request_canceled": "Approval request canceled",
  "webhook_event_approval_request_rejected": "Approval request declined",
  "webhook_event_employee_employment_changed": "Employee employment changed",
  "webhook_event_employee_compensation_changed": "Employee compensation changed",
  "webhook_event_employee_hired": "Employee hired",
  "webhook_event_employee_notification": "Personal notification to employee",
  "webhook_event_employee_position_changed": "Employee position changed",
  "webhook_event_employee_terminated": "Employee terminated",
  "webhook_event_esign_envelope_completed": "E-signature envelope completed",
  "webhook_event_job_created": "Job created",
  "webhook_event_job_deleted": "Job deleted",
  "webhook_event_job_status_changed": "Job status changed",
  "webhook_event_job_updated": "Job updated",
  "webhook_event_required": "Select at least one event type",
  "webhook_event_survey_completed": "Survey completed",
  "webhook_event_task_archived": "Task archived",
  "webhook_event_task_completed": "Task completed",
  "webhook_event_time_off_request_approved": "Time off request approved",
  "webhook_event_types": "Event types",
  "webhook_event_workflow_execution_completed": "Flow execution completed",
  "webhook_header_duplicate": "A header with this name already exists",
  "webhook_header_edit": "Edit header",
  "webhook_header_forbidden": "This header is managed by the system and cannot be overridden",
  "webhook_header_invalid": "Enter a valid HTTP header name",
  "webhook_header_name": "Header name",
  "webhook_header_value": "Header value",
  "webhook_header_value_invalid": "Header values cannot contain line breaks",
  "webhook_http_code": "HTTP code",
  "webhook_load_error": "Webhooks could not be loaded",
  "webhook_load_error_description": "Check your connection and try again.",
  "webhook_operation_error": "The operation could not be completed. Try again.",
  "webhook_redeliver": "Redeliver",
  "webhook_redelivery_failed": "Redelivery failed",
  "webhook_redelivery_succeeded": "Redelivery succeeded",
  "webhook_response": "Response",
  "webhook_rotate_secret": "Rotate secret",
  "webhook_rotate_secret_description": "The current secret will stop working immediately. You will only see the new secret once.",
  "webhook_secret": "Signing secret",
  "webhook_secret_description": "Copy and store this secret now. For security reasons, it will not be shown again.",
  "webhook_secret_title": "Save your signing secret",
  "webhook_status_inactive": "Inactive",
  "webhook_test_delivery": "Test delivery",
  "webhook_test_failed": "Test delivery failed",
  "webhook_test_succeeded": "Test delivery succeeded",
  "webhook_url_invalid": "Enter a valid URL",
  "service_users_description": "Create and manage service users",
  "settings_import_data": "Import data",
  "settings_import_data_description": "Bulk adding or updating data from files",
  "settings_job_archiving_reasons_description": "Configure reasons for archiving job postings",
  "settings_legal_entities_description": "Manage your company's legal structure",
  "settings_locations_description": "Manage office and remote work settings",
  "settings_organization_description": "Set up your company's core identity and working preferences",
  "settings_organization_links_description": "Manage links for employees",
  "settings_pipelines_description": "Design your hiring stages and flow",
  "settings_job_profiles_description": "Manage job profiles, roles, levels, tracks, and grades",
  "settings_probation_policies_description": "Define and manage rules for employee probation periods",
  "settings_roles_and_permissions_description": "Control who can access what",
  "settings_security_description": "Management of password complexity, two-factor authentication, and more",
  "settings_security_title": "Security settings",
  "settings_account_label": "Account",
  "settings_account_manage": "Manage",
  "settings_general_description": "Manage organisation & features",
  "settings_analytics_title": "Analytics & reporting",
  "settings_analytics_description": "Configure how workforce metrics and reports are calculated for your organisation",
  "settings_metrics_configuration_caption": "Configure how your organisation's metrics are calculated",
  "settings_metrics_configuration_retention_title": "Metrics regarding retention",
  "settings_metrics_configuration_retention_caption": "These settings affect how retention, attrition, and internal mobility data is reported across your dashboards",
  "settings_company_structure_title": "Company structure",
  "settings_company_structure_description": "Departments, positions, locations",
  "settings_policies_title": "Policies",
  "settings_policies_description": "Time-off, approval, holidays",
  "settings_employment_title": "Employment",
  "settings_employment_description": "Contract, compensation, termination",
  "settings_employee_profile_title": "Employee profile",
  "settings_recruitment": "Recruitment",
  "settings_recruitment_directories_title": "Recruitment directories",
  "settings_recruitment_directories_description": "Tags, sources, disqualification and job closure reasons",
  "settings_platform": "Platform",
  "settings_personal_account_title": "Manage your account",
  "settings_personal_account_caption": "In account settings",
  "settings_personal_info_title": "Manage personal info",
  "settings_personal_info_caption": "In your profile",
  "settings_hiring_flows_description": "Manage new employee creation",
  "settings_sources_description": "Track where candidates come from",
  "settings_tags_description": "Label candidates by skills and qualifications",
  "settings_templates_description": "Create standard messages",
  "settings_termination_leave_types_description": "Set standard leave type options for ending employment",
  "settings_termination_reasons_description": "Set standard options for ending employment",
  "settings_work_patterns_description": "Set up standard work schedules and weekly hour patterns",
  "show_full_salary": "Show full salary",
  "show_full_salary_description": "Display full salary amounts wherever compensation data is available",
  "sign_up_accept_invitation_agree": "By accepting invitation, you agree with %APP_NAME%'s",
  "state": "State",
  "step_of": "Step {currentStep} of {countSteps}",
  "structure": "Company",
  "successfully_created_profile": "You’ve successfully created a profile for {employee_name}",
  "talent": "Talent",
  "team": "Team",
  "team_lead": "Team lead",
  "team_leads": "Team leads",
  "team_profile": "Team profile",
  "teams": "Teams",
  "terminate_employee": "Terminate employee",
  "terminate_employee_menu_caption": "Start employee termination",
  "termination": "Termination",
  "termination_comment": "Termination comment",
  "termination_date": "Termination date",
  "to_everyone": "Everyone",
  "termination_history_update_required": "Refresh employee history before editing or deleting this termination record.",
  "termination_leave_types": "Leave types",
  "termination_reason": "Termination reason",
  "termination_reason_delete_confirm": "Do you want to remove reason?",
  "termination_reasons": "Termination reasons",
  "time_off_balances": "Time off balances",
  "to_up": "Up",
  "total": "Total",
  "turn_off": "Turn off",
  "two_factor": "Two-factor verification",
  "two_factor_cant_scan_qr": "Can't scan the QR code?",
  "two_factor_disable": "Disable two-factor authentication",
  "two_factor_disable_caption": "Your account will become less secure.",
  "two_factor_enabled": "Two-factor verification enabled",
  "two_factor_enter_code": "Enter verification code",
  "two_factor_from_authenticator": "From authenticator app",
  "two_factor_scan_qr": "Scan this QR code with Google Authenticator or another compatible app",
  "two_factor_setup": "Two-factor setup",
  "two_factor_setup_authenticator_app": "Setup authenticator app",
  "two_factor_setup_warning_logout_20_min": "Without two-factor authentication, you will be logged out in 20 minutes",
  "unlimited": "Unlimited",
  "upcoming_birthdays": "Upcoming birthdays",
  "update_role_from_settings_caption": "All current settings will be replaced with the ones you're copying",
  "update_role_from_settings_title": "Update an existing role",
  "update_settings_in_x_roles": "Update settings in {in_count_roles}",
  "update_view": "Update \"{title}\"",
  "upload_photo": "Upload photo",
  "upload_photo_caption": "Upload or change the employee's profile photo",
  "use_ssl": "Use SSL",
  "view_filters_count": "{count, plural, =0 {No filters} one {# filter} other {# filters}}",
  "view_name": "View name",
  "view_on_calendar": "View on calendar",
  "view_profile": "View profile",
  "view_recipient_profile": "View recipient profile",
  "view_sender_profile": "View sender profile",
  "visibility_managed_by_organization": "Visibility managed by organization settings",
  "want_less_security": "Want less security",
  "warning_cant_undo": "This action is final — changes can't be undone",
  "welcome_after_email_confirm_description": "We're thrilled to have you join %APP_NAME%, the ultimate tool for making your hiring process smoother and more efficient. You're all set to transform how you find, engage, and hire top talent.",
  "welcome_after_email_confirm_install_chrome": "Install uur Chrome extension",
  "welcome_after_email_confirm_install_chrome_button": "Install Chrome extension",
  "welcome_after_email_confirm_install_chrome_description": "Enhance your hiring process with our Google Chrome extension, designed to help you source candidates effortlessly as you browse the web",
  "welcome_after_email_confirm_invite_your_team": "Invite your team",
  "welcome_after_email_confirm_invite_your_team_button": "Invite team members",
  "welcome_after_email_confirm_invite_your_team_description": "Collaborate effectively by inviting your colleagues to join %APP_NAME%",
  "welcome_after_email_confirm_title": "Thank You for Confirming Your Email!",
  "welcome_after_email_confirm_title_2": "Welcome to %APP_NAME%!",
  "welcome_after_email_confirm_whats_next": "What's Next?",
  "welcome_to_platform": "Welcome to %APP_NAME%!",
  "work_email": "Work email",
  "work_email_copied": "Work email copied",
  "work_info": "Work info",
  "work_pattern": "Work pattern",
  "work_patterns": "Work patterns",
  "working_days": "Working days",
  "your_team_growing": "Your team just keeps growing!",
  "your_teammate_birthday_today": "Your teammate has birthday today!",
  "zip": "Zip",
  "~": "~",
  "no_folders_created": "No folders yet",
  "document_folders": "Document folders",
  "settings_documents_description": "Manage folders and documents for employees",
  "permissions_manage_documents_description": "Manage folders for storing employee documents",
  "employee_documents": "Employee folders",
  "organization_documents": "Company documents",
  "view_documents_rules": "Visible to",
  "view_documents_rules_caption": "Define who can view this folder and its documents.",
  "edit_documents_rules": "Managed by",
  "edit_documents_rules_caption": "Define who can add, edit, and delete documents in this folder. Editors automatically have viewing access.",
  "employee_folder_permissions_none_description": "Folder is hidden from the employee",
  "employee_folder_permissions_view_description": "Employee can view documents",
  "employee_folder_permissions_edit_description": "Employee can view and manage documents",
  "employee_workflow_permissions_run_title": "Start flows",
  "employee_workflow_permissions_run_description": "Flows this role can start for employees whose data it can access",
  "employee_workflow_permissions_run_edit_title": "Can start",
  "employee_workflow_permissions_executions_title": "Flow runs",
  "employee_workflow_permissions_executions_description": "Runs of each flow for employees whose data this role can access",
  "employee_workflow_permissions_executions_view_title": "View",
  "employee_workflow_permissions_executions_edit_title": "View and cancel",
  "employee_workflow_permissions_executions_none_description": "Employee cannot see the flow runs",
  "employee_workflow_permissions_executions_view_description": "Employee can view the flow runs",
  "employee_workflow_permissions_executions_edit_description": "Employee can view and cancel the flow runs",
  "folder_roles_modal_setup_field_permissions": "Setup folder permissions",
  "folder_roles_modal_new_field_ready": "Nice! New folder is ready!",
  "folder_roles_modal_new_field_created": "New folder created",
  "folder_roles_modal_lets_choose": "Let's get it set up",
  "folder_roles_modal_who_should_see": "Who should see this folder?",
  "folder_roles_modal_set_access": "Set access for each role in your workspace:",
  "folder_roles_modal_who_can_configure": "These teammates can configure access:",
  "folder_roles_modal_apply_access": "Apply access rules",
  "folder_roles_modal_manage_roles": "Manage in workspace settings",
  "folder_roles_modal_new_field_is_hidden": "This new folder is hidden for now",
  "folder_roles_modal_new_field_is_hidden_information": "No one, including you, can see or use it until access is granted in role permissions. You don't have permission to make it visible or allow document management.",
  "folder_roles_modal_need_help_question": "Need help setting it up further?",
  "folder_roles_modal_ok_got_it": "Ok, got it",
  "turn_on_reminders": "Turn on reminders",
  "notifications_and_reminders": "Notifications and reminders",
  "notifications_and_reminders_description": "Configure engagement methods",
  "reminder_channels_description": "Choose where to notify and remind",
  "choose_reminder_frequency": "Choose frequency of reminders",
  "reminder_mode_gentle": "Gentle",
  "reminder_mode_gentle_description": "A few reminders closer to the deadline",
  "reminder_mode_balanced": "Balanced",
  "reminder_mode_balanced_description": "Regular reminders throughout the period",
  "reminder_mode_persistent": "Persistent",
  "reminder_mode_persistent_description": "Frequent reminders with extra nudges near the deadline",
  "reminder_mode_custom": "Custom",
  "reminder_mode_custom_description": "Set your own reminder interval",
  "reminder_count_info": "Up to {reminders} over {days}",
  "reminder_mode": "{level} mode",
  "remind_every_masculine": "{count, plural, one{Remind every} other{Remind every}}",
  "remind_every_feminine": "{count, plural, one{Remind every} other{Remind every}}",
  "reminder_period_day": "{count, plural, one{day} other{days}}",
  "reminder_period_week": "{count, plural, one{week} other{weeks}}",
  "reminder_period_month": "{count, plural, one{month} other{months}}",
  "reminder_requires": "Smart reminders require a {needed}",
  "reminder_requires_due_date": "set due day",
  "reminder_requires_due_date_days": "due date",
  "reminder_requires_period": "set review period",
  "reminder_requires_period_description": "Add start and end dates to enable smart reminders",
  "reminder_requires_future_date": "future end date",
  "reminder_requires_future_date_description": "Set an end date that is greater than the current date to enable smart reminders",
  "external_channels": "External Channels",
  "no_employee_folders_description": "Add one folder to every profile. \nUpload a file per person.",
  "no_org_folders_description": "Create folders for the whole company. \nUpload files everyone can see.",
  "career_architecture": "Career architecture",
  "manage_framework": "Manage framework",
  "create_job_role": "Create job role",
  "edit_job_role": "Edit job role",
  "delete_job_role_title": "Delete job role",
  "delete_role": "Delete role",
  "delete_job_role_description": "Are you sure you want to delete this job role? This action cannot be undone.",
  "grade": "Grade",
  "grades": "Grades",
  "track": "Track",
  "tracks": "Tracks",
  "manage_grade_scale": "Manage grade scale",
  "manage_job_tracks": "Manage job tracks",
  "setup_grade_names_for_each_track": "Setup grade names for each track",
  "career_framework_empty_description": "Add grades and tracks to build your career framework.",
  "job_catalog_tracks": "Job tracks",
  "job_catalog_grades": "Job grades",
  "job_track_archived": "This track is archived",
  "job_grade_archived": "This grade is archived",
  "job_track_and_grade_archived": "This track and grade are archived",
  "job_level_archived": "This level is archived",
  "create_job_level": "Create level",
  "edit_job_level": "Edit level",
  "delete_job_level_title": "Delete level",
  "delete_job_level_description": "Are you sure you want to delete this level? This action cannot be undone",
  "edit_levels": "Edit levels",
  "used_by": "Used by {target}",
  "job_profiles": "Job profiles",
  "edit_job_profiles": "Editing job profiles",
  "job_profile": "Job profile",
  "job_profile_employees_empty": "No employees are using this profile",
  "job_profile_employees_load_error": "Employees could not be loaded",
  "job_profile_for_role": "{title} for {role}",
  "display_name": "Display name",
  "original_name_hint": "Original name: {name}",
  "reset_to_original": "Reset to original",
  "salary_min": "Min gross",
  "salary_max": "Max gross",
  "fte": "FTE",
  "standard_weekly_hours": "Standard weekly hours",
  "standard_weekly_hours_hint": "Used as the denominator when calculating FTE.",
  "standard_weekly_hours_inherit_org": "Leave empty to inherit from the organization.",
  "standard_weekly_hours_inherit_legal_entity": "Leave empty to inherit from the employee's legal entity.",
  "job_profile_description": "Job profile description",
  "job_profile_description_hint": "Displayed in Job profile tooltips",
  "move_job_profile": "Move",
  "move_job_profile_to_another_role": "Move to another role",
  "move_job_profile_to_another_level": "Move to another level",
  "job_profile_moved_to_role": "Job position moved to {role}",
  "job_profile_moved_to_level": "Job position moved to {level}",
  "confirm_job_profile_replacement": "Confirm replacement",
  "job_profile_replacement_confirmation": "A job profile for <strong>{level}</strong> already exists in {role}. Replace it with a copy of the current profile?",
  "replace_job_position": "Replace job position",
  "new_job_position_created": "New job position created in {role}",
  "job_role": "Job role",
  "job_roles": "Job roles",
  "job_level": "Job level",
  "reassign_before_deleting": "Reassign them before deleting",
  "employee_position_change_reasons": "Position change reasons",
  "employee_position_change_reason": "Position change reason",
  "settings_employee_position_change_reasons_description": "Configure reasons for employee position changes",
  "column_filter_is_empty": "Empty",
  "column_filter_is_filled": "Filled",
  "add_or_search_filter": "Add or search filter",
  "edit_filters": "Edit filters",
  "your_filters": "Your filters",
  "column_filter_contains": "Contains",
  "column_filter_in_range": "In range",
  "column_filter_in_period": "In period",
  "column_filter_any_of": "Any of",
  "column_filter_range_invalid": "“From” is greater than “To”",
  "column_filter_text_placeholder": "Part of the value",
  "rule_group_by_candidate_job": "By job",
  "rule_candidate_job_recruiters": "Job recruiters",
  "rule_candidate_job_recruiters_caption": "Recruiters of the candidate's job",
  "rule_candidate_job_stakeholders": "Job stakeholders",
  "rule_candidate_job_stakeholders_caption": "Stakeholders of the candidate's job",
  "rule_group_base_active": "We count active employees only",
  "rule_group_hidden_rules_note": "Counts include additional restrictions.",
  "rule_group_preview_error": "Employee counts could not be loaded.",
  "rule_group_role_preview_note": "Coverage is calculated relative to employees with this role.",
  "rule_group_visible_only": "The preview lists only employees you have permission to view."
}
